<template>
  <!-- v-if="isGenTrackingCode" -->
  <div 
    class="card shadow m-3 position-fixed right-0 top-0" 
    style="z-index:1; width: 320px;"
  >
    <div class="card-body d-flex align-items-center">
      <div 
        :class="{ 'rotate': (!complete && !error) }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-3 border-2 border-primary text-primary"
        style="width:50px; height:50px;"
        ref="progressIcon"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>

      <div class="w-100">
        <div 
          class="progress rounded-round mb-2" 
          style="height:12px"
        >
          <div 
            class="progress-bar bg-primary rounded-round" 
            :style="`width:${progressBarWidth}%;`"
            ref="progressBar"
          >
            <!-- <span class="label-percent"></span> -->
          </div>
        </div>
        <div 
          v-if="complete && !error"
          class="d-inline-block"
          style="max-width: 180px;"
        >
          <a 
            :href="fullPath" 
            download
            @click="downloadReportFile"
          >
            {{ fileName }}
          </a>
        </div>
        <div v-else-if="!complete && error">
          {{ $t('Error') }}
        </div>
        <div v-else>
          {{ $t('Downloading') }}
        </div>
      </div>
      <button 
        :class="{ 'text-muted': !closeModal }" 
        @click="cancelGenerateFileDownload()" 
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>
  </div>
</template>
<script>
import Api from '@/services/endpoint/tenant.service'
import WebSocket from "isomorphic-ws"
import { mapGetters } from 'vuex'
import Cookies from "js-cookie";

export default {
  data() {
    return {
      closeModal: false,
      progressBarWidth: 0,
      total: 0,
      offset: 0,
      websocket: null,
      complete: false,
      error: false,
      tenantId: null,
      fileName: null,
      fullPath: null
    }
  },
  computed: {
    ...mapGetters({
      queryString: 'reports/getQueryString',
      temp: 'reports/getTemp'
    }),
  },
  async mounted() {
    let generateReports = await this.$store.dispatch("reports/getGenerateReportsLocalStorage");
    if (generateReports) {
      generateReports = JSON.parse(generateReports)
      this.total = generateReports.total
      this.offset = generateReports.offset
      this.tenantId = generateReports.tenantId
      this.progressBarWidth = generateReports.progressBarWidth
      this.fileName = generateReports.fileName
      this.fullPath = generateReports.fullPath
      if (!generateReports.fullPath) {
        await this.openWebsocket()
        await this.resumeGenerateDownloadReport(generateReports)
      } else {
        this.complete = true
      }
    }

    // action tranfer data
    if (this.temp && this.queryString == null) {
      this.tenantId = (JSON.parse(Cookies.get('tenant'))).id
      this.$store.dispatch("reports/queryStringReportShippingChargeBilling", {
        action: 'GET'
      });
      await this.openWebsocket()
      await this.startGenerateDownloadReport()
    }
  },
  methods: {
    cancelGenerateFileDownload() {
      this.$store.dispatch("reports/isProgressReportShippingChargeBilling", false);
      if (this.fullPath) {
        this.$store.dispatch("reports/removeGenerateReportsLocalStorage");
      }
    },
    openWebsocket() {
      let vm = this;
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      // Open websocket
      ws.onopen = function open() {
        ws.send(JSON.stringify({
          "data": {
            "clientUid": `export_report_shiping_charge_billing.${vm.tenantId}`
          },
          "event": "subscribe"
        }));
      };
      ws.onmessage = function incoming (message) {
      let data = JSON.parse(message.data)
        if (data.event == 'export_report_shiping_charge_billing') {
          vm.total = data.data.total
          vm.offset = data.data.offset
          vm.progressBarWidth = data.data.progressBarWidth
          // complete
          if (data.data.progressBarWidth == 100) {
            vm.complete = true;
            vm.fileName = data.data.fileName
            vm.fullPath = data.data.fullPath
          }
          // get and update cookies
          if (data.data.status) {
            vm.$store.dispatch("reports/removeGenerateReportsLocalStorage");
            vm.$store.dispatch("reports/setGenerateReportsLocalStorage", JSON.stringify(data.data));
          } else {
            vm.complete = false;
            vm.error = true;
            let progressBar = vm.$refs.progressBar.classList
            progressBar.remove("bg-primary")
            progressBar.add("bg-danger")
            let progressIcon = vm.$refs.progressIcon.classList
            progressIcon.remove("border-primary", "text-primary")
            progressIcon.add("border-danger", "text-danger")
            vm.$store.dispatch("reports/removeGenerateReportsLocalStorage");
          }
        }
      }
    },
    async startGenerateDownloadReport() {
      let response = await Api.ReportV2.getShippingChargeBillingDetailDownload(this.queryString)
      this.$store.dispatch("reports/setGenerateReportsLocalStorage", JSON.stringify({
        fileName: response.data.data.file_name,
        offset: response.data.data.offset,
        total: response.data.data.total,
        queryString: this.parseQueryString(this.queryString),
        progressBarWidth: 0,
        tenantId: this.tenantId
      }))
      this.$store.dispatch("reports/queryStringReportShippingChargeBilling", {
        action: 'DEL'
      });
    },
    async resumeGenerateDownloadReport(generateReports) {
      let queryStringClone = generateReports.queryString
      let queryString = "";
      queryStringClone.offset = generateReports.offset
      if (queryStringClone) {
        queryString += "?" + $.param(queryStringClone);
      }
      await Api.ReportV2.getShippingChargeBillingDetailDownload(queryString)
      this.$store.dispatch("reports/queryStringReportShippingChargeBilling", {
        action: 'DEL'
      });
    },
    downloadReportFile() {
      this.$store.dispatch("reports/removeGenerateReportsLocalStorage");
      setTimeout(() => {
        this.cancelGenerateFileDownload()
      }, 3000);
    },
    parseQueryString(queryString) {
      let params = {};
      params.shipping_method_ids = [];
      let keyValuePairs = queryString.slice(1).split('&');
      for (let pair of keyValuePairs) {
        let [key, value] = pair.split('=');
        if (key === "shipping_method_ids%5B%5D") { 
          params.shipping_method_ids.push(value);
        } else {
          params[key] = decodeURIComponent(value);
        }
      }
      return params;
    }
  },
  beforeDestroy() {
    if (this.websocket) {
      this.websocket.close();
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ModalDownloadReportShippingChargeBilling.vue